var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoonbeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#53CBC8;}\n\t.st1{fill:#E1147B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-195.593 -194.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "symbol"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    className: "st0",
    d: "M248.5,204.5c-14.3,0-25.8,11.6-25.8,25.9l0,0c0,0,0,0,0,0.1v0c0,0.7,0.6,1.2,1.3,1.2H273 c0.7,0,1.2-0.5,1.3-1.2v0c0,0,0,0,0-0.1l0,0C274.3,216,262.7,204.5,248.5,204.5L248.5,204.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    className: "st1",
    d: "M205.5,259.2c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6l0,0 C204.8,257.6,205.5,258.3,205.5,259.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    className: "st1",
    d: "M271.3,250.5h-52.7c-0.9,0-1.5,0.7-1.5,1.6c0,0.3,0.1,0.5,0.2,0.7l0,0c0.3,0.5,0.8,0.8,1.4,0.8 h52.7c0.6,0,1.1-0.3,1.4-0.8l0,0c0.4-0.8,0.1-1.7-0.6-2.1C271.8,250.5,271.6,250.5,271.3,250.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    className: "st1",
    d: "M278.3,236.2h-59.7c-0.9,0-1.6,0.7-1.5,1.6c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0.8,0.7,1.5,1.5,1.5 h59.7c0.8,0,1.5-0.6,1.5-1.5c0,0,0,0,0,0C279.9,237,279.3,236.3,278.3,236.2C278.4,236.2,278.4,236.2,278.3,236.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    className: "st1",
    d: "M255.8,271.9h-26.9c-0.9,0-1.5,0.7-1.5,1.6c0,0.6,0.3,1.1,0.9,1.4l0.1,0 c0.2,0.1,0.5,0.2,0.7,0.2h26.7c0.2,0,0.5-0.1,0.7-0.2l0.1,0c0.8-0.4,1.1-1.3,0.7-2.1C257,272.2,256.4,271.9,255.8,271.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    className: "st1",
    d: "M272.3,264.7h-26.9c-0.9,0-1.5,0.7-1.5,1.6c0,0.6,0.3,1.1,0.9,1.4l0.1,0 c0.2,0.1,0.5,0.2,0.7,0.2h26.7c0.2,0,0.5-0.1,0.7-0.2l0.1,0c0.8-0.4,1.1-1.3,0.7-2.1C273.4,265.1,272.9,264.7,272.3,264.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    className: "st1",
    d: "M235.6,260.3L235.6,260.3c-0.6-0.7-0.6-1.7,0-2.2c0.3-0.3,0.7-0.4,1-0.4h43.7 c0.9,0,1.5,0.7,1.5,1.6c0,0.4-0.1,0.8-0.4,1l0,0c-0.3,0.3-0.7,0.5-1.1,0.5h-43.6C236.3,260.8,235.9,260.6,235.6,260.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    className: "st1",
    d: "M209.6,257.6h20.9c0.9,0,1.5,0.7,1.5,1.6c0,0.6-0.3,1.1-0.9,1.4l-0.1,0 c-0.2,0.1-0.5,0.2-0.7,0.2h-20.7c-0.2,0-0.5-0.1-0.7-0.2l-0.1,0c-0.8-0.4-1.1-1.3-0.7-2.1C208.5,257.9,209,257.6,209.6,257.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    className: "st1",
    d: "M214.6,237.8c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6 C213.9,236.2,214.6,236.9,214.6,237.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    className: "st1",
    d: "M251.6,245.3L251.6,245.3c0.2-0.9-0.3-1.7-1.1-1.9c-0.1,0-0.3-0.1-0.4-0.1h-43.7 c-0.9,0-1.6,0.7-1.6,1.5c0,0.1,0,0.3,0.1,0.4c0,0,0,0,0,0c0.2,0.7,0.8,1.1,1.5,1.1h43.7C250.8,246.5,251.5,246,251.6,245.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    className: "st1",
    d: "M202.4,244.9c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6 C201.7,243.3,202.4,244.1,202.4,244.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    className: "st1",
    d: "M214.6,252.1c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6 C213.9,250.5,214.6,251.2,214.6,252.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    className: "st1",
    d: "M241.3,266.3c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6l0,0 C240.6,264.7,241.3,265.4,241.3,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    className: "st1",
    d: "M224.9,273.4c0,0.9-0.7,1.6-1.6,1.6s-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6 C224.2,271.9,224.9,272.6,224.9,273.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonbeam);
export default __webpack_public_path__ + "static/media/moonbeam.1e45161cfa9ce1fc7042b5a02bd86092.svg";
export { ForwardRef as ReactComponent };